import { getFileUrl } from './fileUtils';

export function normalizeNombreClero(s) {
  return (s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/^(monsenor|monseñor|padre|p\.|rev\.|sr\.|sra\.)\s+/i, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function soloDigitos(s) {
  return (s || '').replace(/\D/g, '');
}

export function normalizeFotoPathClient(url) {
  if (!url) return null;
  let s = String(url).trim();
  if (!s) return null;
  if (s.startsWith('http://') || s.startsWith('https://')) {
    try {
      const u = new URL(s);
      if (u.pathname.includes('/uploads/')) {
        const idx = u.pathname.indexOf('/uploads/');
        return u.pathname.slice(idx);
      }
      return s;
    } catch {
      return s;
    }
  }
  if (!s.startsWith('/')) s = `/${s}`;
  return s;
}

/** Todas las URLs posibles para un archivo en /uploads (nginx, estático API, proxy media) */
export function buildUploadImageCandidates(fotoUrl) {
  const path = normalizeFotoPathClient(fotoUrl);
  if (!path || !path.includes('/uploads/')) {
    if (String(fotoUrl || '').startsWith('http')) return [String(fotoUrl).trim()];
    return [];
  }

  const list = [];

  if (typeof window !== 'undefined' && window.location?.origin) {
    const origin = window.location.origin;
    // 1) Node estático (/api/uploads) — funciona aunque nginx /uploads falle
    list.push(`${origin}/api${path}`);
    // 2) Ruta directa cuando nginx esté bien configurado
    list.push(`${origin}${path}`);
    // 3) Proxy opcional
    list.push(`${origin}/api/media/file?path=${encodeURIComponent(path)}`);
  } else {
    list.push(`/api${path}`, path, `/api/media/file?path=${encodeURIComponent(path)}`);
  }

  const viaFile = getFileUrl(path);
  if (viaFile && !list.includes(viaFile)) list.unshift(viaFile);

  if (String(fotoUrl).startsWith('http')) {
    const ext = String(fotoUrl).trim();
    if (!list.includes(ext)) list.push(ext);
  }

  return [...new Set(list.filter(Boolean))];
}

export function nombresCoincidenClero(a, b) {
  const na = normalizeNombreClero(a);
  const nb = normalizeNombreClero(b);
  if (!na || !nb) return false;
  if (na === nb) return true;
  if (na.includes(nb) || nb.includes(na)) return true;
  const pa = na.split(' ').filter((w) => w.length > 2);
  const pb = nb.split(' ').filter((w) => w.length > 2);
  if (!pa.length || !pb.length) return false;
  const compartidos = pa.filter((w) => pb.includes(w));
  return compartidos.length >= Math.min(2, Math.min(pa.length, pb.length));
}

/**
 * Une directorio presbiteral con fotos de GET /autoridades (misma fuente que «Acerca»).
 */
export function mergeCleroConAutoridades(cleroList, autoridades) {
  if (!Array.isArray(cleroList) || cleroList.length === 0) return cleroList;

  const aut = (autoridades || [])
    .map((a) => ({
      ...a,
      foto_url: normalizeFotoPathClient(a.foto_url)
    }))
    .filter((a) => a.foto_url);

  const fotoObispo = aut.find((a) => /obispo/i.test(a.cargo || '') && a.foto_url)?.foto_url || null;

  return cleroList.map((p) => {
    let foto = normalizeFotoPathClient(p.foto_url);
    if (foto) return { ...p, foto_url: foto };

    const nombre = p.nombreCompleto || p.nombre_completo || '';
    const email = (p.email || '').trim().toLowerCase();
    const cel = soloDigitos(p.celular);

    for (const a of aut) {
      const mailA = (a.email || '').trim().toLowerCase();
      if (email && mailA && email === mailA) {
        foto = a.foto_url;
        break;
      }
      const telA = soloDigitos(a.telefono);
      if (cel.length >= 10 && telA.length >= 10 && cel.slice(-10) === telA.slice(-10)) {
        foto = a.foto_url;
        break;
      }
      if (nombresCoincidenClero(nombre, a.nombre)) {
        foto = a.foto_url;
        break;
      }
    }

    if (!foto && /obispo/i.test(p.cargo || '') && fotoObispo) {
      foto = fotoObispo;
    }

    return foto ? { ...p, foto_url: foto } : p;
  });
}

/** @deprecated use buildUploadImageCandidates */
export function buildCleroFotoCandidates(fotoUrl) {
  return buildUploadImageCandidates(fotoUrl);
}
